import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import TopBar from '../../components/TopBar'
import Footer from '../../components/Footer'
import { Fade } from "react-awesome-reveal";
import { isMobileDevice } from "../../utils";
import { useNavigate } from "react-router";
import { productConceptPage } from "../../API";
import Pagination from "../../components/Pagination";

const ComponentName: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate()

  const [page, setPage] = React.useState(1)
  const [pageSize, setPageSize] = React.useState(20)
  const [totalPages, setTotalPages] = React.useState(0)
  const [list, setList] = React.useState<any>()
  const handleLoad = () => {
    productConceptPage({
      "pageNum": page,
      "pageSize": pageSize,
    }).then(res => {
      setList(res.data.records)
      setTotalPages(res.data.total)
    }).catch(err => {
      console.log(err)
    })
  }
  useEffect(() => {
    handleLoad()
  }, [page])

  return (
    <div className="">
      <TopBar />
      <div className="relative"
        style={{
          backgroundImage: `url(${require("../../assets/image/icon15.png")})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }} >
        <div className="text-[#181512] text-[45px] py-[118px] font-[700] w-[955px] mx-auto 
        h5:text-center h5:text-[30px] h5:w-full h5:py-[68px] relative z-10">詩肯概念展示</div>

        <div className="absolute top-0 left-0 right-0 bottom-0"
          style={{
            background: 'linear-gradient(to right, #fbfbfbc2, transparent)',
            bottom: '0',
            content: "",
            left: '0',
            pointerEvents: 'auto',
            position: 'absolute',
            right: '0',
            top: '0',
            zIndex: 1
          }}></div>
      </div>


      <div className={`grid gap-0 ${isMobileDevice() ? 'grid-cols-1' : 'grid-cols-2'} pt-[120px] pb-[100px] w-[960px] mx-auto h5:pt-[60px] h5:w-full`}>
        {
          list && list.map((item: any, index: React.Key | null | undefined) => (
            <div key={index}>
              <Fade
                cascade={true}
                direction="up"
                delay={200}
                duration={800}
                triggerOnce={true}
              >
                <div className="px-15 pb-[40px] cursor-pointer hover:-translate-y-1 duration-200"
                  onClick={() => {
                    navigate('/exhibit/detail?id=' + item?.id)
                  }}>
                  <div
                    className="h-[253px] transition-transform duration-300 hover:scale-120 overflow-hidden"
                    style={{
                      backgroundImage: `url(${item?.showImgUrl})`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      backgroundRepeat: "no-repeat",
                    }}
                  ></div>

                  <div className="bg-[#f6f5f1] pt-[40px] px-[30px] pb-[45px] mx-20 mt-[-40px]">
                    <div className="text-[#181512] text-[25px] font-bold mb-[30px] line-clamp-1">{item?.title}</div>
                    <div className="text-[#181512] text-[17px] inline-block pb-4"
                      style={{
                        borderBottom: "1px dashed #e0d9c6"
                      }}
                    >View showroom {'>'}</div>
                  </div>
                </div>
              </Fade>
            </div>
          ))
        }
      </div>

      <div className="flex justify-center pb-[75px]">
        {
          Math.ceil(totalPages / pageSize) > 1 ?
        <Pagination
          totalPages={Math.ceil(totalPages / pageSize)}
              currentPage={page}
          onPageChange={(page: number) => setPage(page)}
            /> : ''
        }
      </div>

      <Footer />
    </div>
  );
};

export default ComponentName;
